module.exports = __webpack_public_path__ + "settingsIcon.png?c50ee9a166ed331d4c059b38d2b92ba6";